import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// English
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enNavigation from './locales/en/navigation.json';
import enDashboard from './locales/en/dashboard.json';
import enErrors from './locales/en/errors.json';
import enDialogs from './locales/en/dialogs.json';
import enLanding from './locales/en/landing.json';
import enPages from './locales/en/pages.json';

// French
import frCommon from './locales/fr/common.json';
import frAuth from './locales/fr/auth.json';
import frNavigation from './locales/fr/navigation.json';
import frDashboard from './locales/fr/dashboard.json';
import frErrors from './locales/fr/errors.json';
import frDialogs from './locales/fr/dialogs.json';
import frLanding from './locales/fr/landing.json';
import frPages from './locales/fr/pages.json';

// Chinese (Mandarin)
import zhCommon from './locales/zh/common.json';
import zhAuth from './locales/zh/auth.json';
import zhNavigation from './locales/zh/navigation.json';
import zhDashboard from './locales/zh/dashboard.json';
import zhErrors from './locales/zh/errors.json';
import zhDialogs from './locales/zh/dialogs.json';
import zhLanding from './locales/zh/landing.json';
import zhPages from './locales/zh/pages.json';

// German
import deCommon from './locales/de/common.json';
import deAuth from './locales/de/auth.json';
import deNavigation from './locales/de/navigation.json';
import deDashboard from './locales/de/dashboard.json';
import deErrors from './locales/de/errors.json';
import deDialogs from './locales/de/dialogs.json';
import deLanding from './locales/de/landing.json';
import dePages from './locales/de/pages.json';

// Spanish
import esCommon from './locales/es/common.json';
import esAuth from './locales/es/auth.json';
import esNavigation from './locales/es/navigation.json';
import esDashboard from './locales/es/dashboard.json';
import esErrors from './locales/es/errors.json';
import esDialogs from './locales/es/dialogs.json';
import esLanding from './locales/es/landing.json';
import esPages from './locales/es/pages.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English', nativeLabel: 'English', flag: '🇬🇧' },
  { code: 'fr', label: 'French', nativeLabel: 'Français', flag: '🇫🇷' },
  { code: 'zh', label: 'Chinese', nativeLabel: '简体中文', flag: '🇨🇳' },
  { code: 'de', label: 'German', nativeLabel: 'Deutsch', flag: '🇩🇪' },
  { code: 'es', label: 'Spanish', nativeLabel: 'Español', flag: '🇪🇸' }
];

export const DEFAULT_LANGUAGE = 'en';

const resources = {
  en: { common: enCommon, auth: enAuth, navigation: enNavigation, dashboard: enDashboard, errors: enErrors, dialogs: enDialogs, landing: enLanding, pages: enPages },
  fr: { common: frCommon, auth: frAuth, navigation: frNavigation, dashboard: frDashboard, errors: frErrors, dialogs: frDialogs, landing: frLanding, pages: frPages },
  zh: { common: zhCommon, auth: zhAuth, navigation: zhNavigation, dashboard: zhDashboard, errors: zhErrors, dialogs: zhDialogs, landing: zhLanding, pages: zhPages },
  de: { common: deCommon, auth: deAuth, navigation: deNavigation, dashboard: deDashboard, errors: deErrors, dialogs: deDialogs, landing: deLanding, pages: dePages },
  es: { common: esCommon, auth: esAuth, navigation: esNavigation, dashboard: esDashboard, errors: esErrors, dialogs: esDialogs, landing: esLanding, pages: esPages }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE,
    defaultNS: 'common',
    ns: ['common', 'auth', 'navigation', 'dashboard', 'errors', 'dialogs', 'landing', 'pages'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;
